import React from 'react';
import { Formik, Field } from 'formik';

// components
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import Input from 'components/Fields/Input';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

interface FormValues {
  program_uuid: string;
}

interface Props {
  rawContent: string;
  onSubmit: (contentString: string, externalAssetId: string) => void;
  formId: string;
  isReadOnly: boolean;
  closePanel: () => void;
}

const PikselContent = ({ rawContent, onSubmit, formId, isReadOnly, closePanel }: Props) => {
  const initialValues: FormValues = {
    program_uuid: rawContent || '',
  };

  const handleSubmit = ({ program_uuid: contentString }: FormValues) => {
    onSubmit(contentString, contentString);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Field
              tag="text_input_program_uuid"
              name="program_uuid"
              label="Program UUID"
              component={Input}
              disabled={isReadOnly}
            />
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default PikselContent;
